import { Cascader } from "antd";
import type { FormItemProps, CascaderProps } from "antd";
import type { BaseSelectRef } from "rc-select";
import { forwardRef, useState } from "react";
import { FormItem } from "./FormItem";

export type FormCascaderHandle = BaseSelectRef;
interface FormSelectProps
  extends Omit<FormItemProps, "name">,
    Pick<
      CascaderProps,
      | "size"
      | "placeholder"
      | "options"
      | "onInputKeyDown"
      | "onSearch"
      | "disabled"
    > {
  name: string | number | (string | number)[];
  formItemStyle?: React.CSSProperties;
}
export const FormCascader = forwardRef<FormCascaderHandle, FormSelectProps>(
  (
    {
      name,
      label,
      rules,
      options = [],
      size,
      placeholder,
      formItemStyle,
      onInputKeyDown,
      onSearch,
      disabled,
      ...props
    },
    ref
  ) => {
    const [dropdownOpen, setDropdownOpen] = useState<boolean>();

    return (
      <FormItem
        name={name}
        label={label}
        rules={rules}
        style={formItemStyle}
        {...props}
      >
        <Cascader
          ref={ref}
          size={size}
          placeholder={placeholder}
          options={options}
          onInputKeyDown={onInputKeyDown}
          onSearch={onSearch}
          open={dropdownOpen}
          disabled={disabled}
        />
      </FormItem>
    );
  }
);

FormCascader.displayName = "FormSelect";
